/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Here mentioned users feature request structure
 */
export const LLM_PROVIDERS = [
  { label: 'Gemini', key: 'GEMINI' },
  { label: 'GPT', key: 'GPT' },
  { label: 'Claude', key: 'Anthropic' },
];

export const LLM_FEATURES = [
  { label: 'Visual Interpreter', key: 'VI' },
  { label: 'Advanced Query', key: 'AQ' },
];
export const LLM_USAGE_PERIODS = [
  { label: 'Last 7 days', key: '7' },
  { label: 'Last 30 days', key: '30' },
  { label: 'Last 90 days', key: '90' },
];
const API = {
  POST_LLM_MODEL: {
    path: '/organizations/:organizationId/llm-model',
    method: 'POST',
  },
    GET_LLM_MODELS: {
    path: '/organizations/:organizationId/llm-model?:query',
    method: 'GET',
  },
    GET_LLM_MODEL_USAGE: {
    path: '/organizations/:organizationId/llm-model/usage?:query',
    method: 'GET',
  },
    GET_LLM_LOGS: {
    path: '/organizations/:organizationId/llm-logs?:query',
    method: 'GET',
  },
    GET_DEFAULT_MODELS_INFORMATION: {
    path: '/system-information?:query',
    method: 'GET',
  },
  POST_DEFAULT_MODELS_INFORMATION: {
    path: '/system-information',
    method: 'POST',
  },
  PATCH_DEFAULT_MODELS_INFORMATION: {
    path: '/system-information/:systemInformationId',
    method: 'PATCH',
  },

};
//
export default API;
